const Card = (theme, skin) => {
  return {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
          boxShadow:
            skin !== "bordered"
              ? "0 1px 2px rgba(26, 35, 50, 0.06)"
              : theme.shadows[0],
          ...(skin === "bordered" && {
            border: `1px solid ${theme.palette.customColors?.border || theme.palette.divider}`,
          }),
          backgroundColor: theme.palette.background.paper,
          "& .card-more-options": {
            marginTop: theme.spacing(-1),
            marginRight: theme.spacing(-3),
          },
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3, 3),
          "& + .MuiCardContent-root, & + .MuiCollapse-root .MuiCardContent-root": {
            paddingTop: 0,
          },
          "& .MuiCardHeader-subheader": {
            fontSize: "0.875rem",
            color: theme.palette.text.secondary,
          },
        },
        title: {
          lineHeight: 1.35,
          fontWeight: 600,
          fontSize: "1.125rem",
          letterSpacing: "-0.01em",
        },
        action: {
          marginTop: 0,
          marginRight: 0,
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3),
          "& + .MuiCardContent-root": {
            paddingTop: 0,
          },
          "&:last-of-type": {
            paddingBottom: theme.spacing(3),
          },
          "& + .MuiCardActions-root": {
            paddingTop: 0,
          },
        },
      },
    },
    MuiCardActions: {
      styleOverrides: {
        root: {
          padding: theme.spacing(2, 3, 3),
          "&.card-action-dense": {
            padding: theme.spacing(0, 2, 2),
            ".MuiCard-root .MuiCardMedia-root + &": {
              paddingTop: theme.spacing(2),
            },
            ".MuiCard-root &:first-of-type": {
              paddingTop: theme.spacing(3),
              paddingBottom: theme.spacing(3),
              "& + .MuiCardContent-root": {
                paddingTop: 0,
              },
              "& + .MuiCardHeader-root": {
                paddingTop: 0,
              },
            },
          },
        },
      },
    },
  };
};

export default Card;
